import axios from 'axios'

export default {
  getHotspots(params) {
    return axios.get('/hotspots', { params })
  }
}
